<template>
  <div>
    <div class="filter">
      <el-form
        label-position="right"
        class="search-form oneline"
        label-width="80px"
        inline
        @submit.native.prevent
        size="small"
      >
        <el-form-item label="">
          <el-input
            size="small"
            v-model="filter.keyword"
            autocomplete="off"
            placeholder="文件名关键字"
            @keyup.enter.native="getData()"
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <AtmTagSelect v-model="filter.tag" :itemId="item.id"></AtmTagSelect>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" size="small" @click="getData()"
            >筛选</el-button
          >
          <el-button size="small" @click="getData(true)">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      :data="items"
      class="mt-10"
      size="small"
      border
      v-loading="loading"
    >
      <el-table-column label="文件名" prop="name" min-width="200">
        <template slot-scope="scope">
          {{ scope.row.name }}
          <el-image
            v-if="isImage(scope.row.url)"
            :ref="`imagePreview${scope.$index}`"
            style="display: none"
            :src="scope.row.url"
            :preview-src-list="[scope.row.url]"
          >
          </el-image>
          <el-tag size="mini" v-if="scope.row.tag">{{ scope.row.tag }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="remark"></el-table-column>
      <el-table-column label="上传日期" prop="remark" align="center">
        <template slot-scope="scope">{{
          $time(scope.row.created_at).format('YYYY-MM-DD HH:mm')
        }}</template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="200">
        <template slot-scope="scope">
          <el-popconfirm
            title="确认删除该附件吗？"
            @confirm="hanldeDelte(scope.row, scope.$index)"
          >
            <el-link
              slot="reference"
              v-permission="
                item.category == 1
                  ? Auth.itemAttachmentDelete
                  : Auth.instrumentAttachmentDelete
              "
              type="danger"
              class="font-12 ml-5"
              :underline="false"
              >删除</el-link
            >
          </el-popconfirm>
          <el-link
            @click="handleDownload(scope.row)"
            type="primary"
            class="font-12 ml-5"
            v-permission="
              item.category == 1
                ? Auth.itemAttachmentDownload
                : Auth.instrumentAttachmentDownload
            "
            >下载</el-link
          >
          <el-link
            @click="handlePreview(scope.row, scope.$index)"
            v-if="isImage(scope.row.url)"
            type="primary"
            class="font-12 ml-5"
            >预览</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt-20"
      :page-size="filter.size"
      :current-page.sync="filter.page"
      @current-change="getData()"
      layout="total, prev, pager, next"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
import { attachmentList, attachmentDelete } from '@/service/getData'

export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      items: [],
      total: 0,
      loading: false,
      filter: {
        item_id: this.item.id || 0,
        tag: '',
        keyword: '',
        size: 20,
        page: 1,
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData(reset = false) {
      if (reset) {
        this.filter.page = 1
        this.filter.tag = ''
        this.filter.keyword = ''
      }
      let data = this.clone(this.filter)
      data.page -= 1
      this.loading = true
      let res = await attachmentList(data)
      if (res.status == 0) {
        this.items = res.data.list
        this.total = res.data.count
        this.loading = false
      }
    },

    async hanldeDelte(item, index) {
      let res = await attachmentDelete(item.id)
      if (res.code == 0) {
        this.items.splice(index, 1)
      }
    },

    handleDownload(file) {
      const x = new window.XMLHttpRequest()
      x.open('GET', file.url, true)
      x.responseType = 'blob'
      x.onload = () => {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = file.name
        a.click()
      }
      x.send()
    },

    isImage(filename) {
      // 常见图片扩展名（可根据需要增减）
      const imageExtensions = [
        'jpg',
        'jpeg',
        'png',
        'gif',
        'bmp',
        'webp',
        'svg',
        'ico',
        'avif',
        'tiff',
      ]

      // 获取文件后缀（最后一个点之后的部分）
      // 如果文件名没有点，则 extension 为整个文件名（此时不会匹配）
      const extension = filename.split('.').pop().toLowerCase()

      // 检查是否在图片扩展名列表中
      return imageExtensions.includes(extension)
    },

    handlePreview(file, index) {
      this.$refs[`imagePreview${index}`].clickHandler()
    },
  },
}
</script>